export enum MatchType {
  CompanyToCompany = "company_to_company",
  ServiceKindToResource = "service_kind_to_ressource",
}
